import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';
import { useCustomPaginatedQuery, useCustomQuery } from 'hooks/reactQuery';

export const useGetPaginatedVouchers = (query, options = {}) => {
  const fetchPaginatedVouchers = async (key, queryToFetch) => {
    return httpClient
      .get('/e-invoice/vouchers/paginated', { params: queryToFetch })
      .then(res => ({
        vouchers: res.data.vouchers || [],
        totalCount: res.data.total || 0
      }))
      .catch(apiErrorHandler);
  };

  return useCustomPaginatedQuery('vouchers', fetchPaginatedVouchers, query, options);
};

export const getVoucher = id => {
  return httpClient
    .get(`/e-invoice/vouchers/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const useGetVoucher = id => {
  return useCustomQuery('voucherDetail', [id], () => getVoucher(id), {
    shouldFetch: !!id
  });
};

export const createVoucher = body => {
  return httpClient
    .post('/e-invoice/vouchers', body)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const updateVoucher = (id, body) => {
  return httpClient
    .patch(`/e-invoice/vouchers/${id}`, body)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const deleteVoucher = id => {
  return httpClient
    .delete(`/e-invoice/vouchers/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const reactivateVoucher = id => {
  return httpClient
    .post(`/e-invoice/vouchers/${id}/reactivate`)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const getVoucherProducts = () => {
  return httpClient
    .get('/e-invoice/vouchers/products')
    .then(response => response.data)
    .catch(apiErrorHandler);
};
